import { isBefore } from "date-fns";
import { FC } from "react";
import { useSelector } from "react-redux";
import { useLocation } from "react-router";

import { Heading, PromoBannerV2, Text } from "@livechat/design-system-react-components";

import bfPromoImage from "assets/img/blackfriday-promo.png";
import { SubscriptionPhase } from "constants/subscription-phase";
import { isExpired } from "helpers/subscription";
import { getItem, saveItem } from "services/local-storage";
import { selectCurrentSubscription, selectSubscriptionPhase } from "store/entities/subscriptions";

const DISCOUNT_CODE = "black90";
const DISPLAY_BANNER_LOCAL_STORAGE_KEY = "blackfriday_banner_2024_displayed";
const BF_2024_END_OF_CAMPAIGN_DATE = "2024-12-02T23:59:59.999Z";

export const BlackFridayBanner2024: FC = () => {
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const subscription = useSelector(selectCurrentSubscription);
  const subscriptionPhase = useSelector(selectSubscriptionPhase);
  const isCampaignActive = isBefore(new Date(), new Date(BF_2024_END_OF_CAMPAIGN_DATE));

  const discountCodeFromParams = searchParams.get("discount");

  if (discountCodeFromParams === DISCOUNT_CODE) {
    saveItem(DISPLAY_BANNER_LOCAL_STORAGE_KEY, true);
  }

  const hasLocalStorageValue = getItem(DISPLAY_BANNER_LOCAL_STORAGE_KEY);

  const displayBanner =
    hasLocalStorageValue &&
    isCampaignActive &&
    [
      SubscriptionPhase.ExpiredTrial,
      SubscriptionPhase.ExpiredPaid,
      SubscriptionPhase.TrialNoCC,
      SubscriptionPhase.TrialCC,
    ].includes(subscriptionPhase);

  if (!displayBanner) {
    return null;
  }

  return (
    <PromoBannerV2 kind="dark" additionalContent={<img src={bfPromoImage} />}>
      <Heading size="lg">⏱️ 90% off HelpDesk monthly plan</Heading>
      <Text>
        {`Switch to a monthly subscription to redeem your coupon for one month of savings on the Team or Business plans. ${isExpired(subscription) ? EXPIRED_LICENSE_DESCRIPTION : ACTIVE_LICENSE_DESCRIPTION}`}
      </Text>
    </PromoBannerV2>
  );
};

const EXPIRED_LICENSE_DESCRIPTION = "Subscribe by December 2, 2024 to activate your discount.";

const ACTIVE_LICENSE_DESCRIPTION =
  "Your 14-day trial stays intact — enjoy it fully before your discount activates. Subscribe by December 2, 2024 to claim your savings!";
